export type PlanKind = 'low' | 'high' | 'combined';

export interface PlanFeatureBullet {
    title: string;
    description?: string;
}

export interface PlanCopy {
    title: string;
    blurb: string;
    bullets: PlanFeatureBullet[];
    combinedPlusHeader?: string;
}

export const PLAN_COPY: Record<PlanKind, PlanCopy> = {
    low: {
        title: 'Low Value Only',
        blurb: 'A low value procurement has an estimated contract value below public procurement thresholds, typically with simplified or less formal procedures.',
        bullets: [
            { title: 'Low value Tender and Contract Award details' },
            { title: 'Low value PINs, Pipeline and Planning notices' },
            { title: 'Extensive search filters across our entire database of low value Tenders' },
            { title: 'Download low value Buyer Documents in your account' },
            { title: 'Personal and team bookmarks' },
            { title: 'Team access up to 10 users' }
        ]
    },
    high: {
        title: 'High Value Only',
        blurb: 'A high value procurement has an estimated contract value at or above public procurement thresholds, typically with full compliance and formal procedures.',
        bullets: [
            { title: 'High value Tender and Contract Award details' },
            { title: 'High value PINs, Pipeline and Planning notices' },
            { title: 'Extensive search filters across our entire database of high value Tenders' },
            { title: 'Download high value Buyer Documents in your account' },
            { title: 'Personal and team bookmarks' },
            { title: 'Team access up to 10 users' }
        ]
    },
    combined: {
        title: 'Combined',
        blurb: '',
        combinedPlusHeader: 'Includes everything in Low & High, plus:',
        bullets: [
            {
                title: 'Bespoke tender alerts',
                description: 'Select additional categories and locations for tailored alerting for individual team members'
            },
            {
                title: 'Company tracking alerts',
                description: 'Select companies to monitor and receive an alert when a company being tracked is awarded a contract'
            },
            {
                title: 'Weekly contract expiry alerts',
                description: 'Identify contracts of interest and select them for notification when the contract is due to expire in 6 months'
            },
            {
                title: 'Full unlimited access to Bid Management',
                description: 'Our Bid Management platform integrates with your account to enable seamless management with your team'
            }
        ]
    }
};

export const PLAN_DISPLAY_ORDER: PlanKind[] = ['low', 'high', 'combined'];



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/subscription/subscription-plan.data.ts